import { defaultTo } from "lodash";
import { IModel, Model, ModelRecord } from "./Model";

export interface IMarketModel extends IModel {
    marketId: number;
    code: string;
    name: string;
    diagnosticLabUserProvided: boolean| undefined;
    diagnosticLabUserName: string| undefined;
    diagnosticLabPassword: string | undefined;
}

export class MarketModel extends Model implements ModelRecord<IMarketModel> {
    marketId: number;
    code: string;
    name: string;
    diagnosticLabUserProvided: boolean| undefined;
    diagnosticLabUserName: string | undefined;
    diagnosticLabPassword: string | undefined;  

    constructor(init?: Partial<IMarketModel>) {
        super(init);
        this.marketId = defaultTo(init?.marketId, 0);
        this.code = defaultTo(init?.code, '');
        this.name = defaultTo(init?.name, '');
        this.diagnosticLabUserProvided = defaultTo(init?.diagnosticLabUserProvided, undefined);
        this.diagnosticLabUserName = defaultTo(init?.diagnosticLabUserName, undefined);
        this.diagnosticLabPassword = defaultTo(init?.diagnosticLabPassword, undefined);
    }

}
